import { render, staticRenderFns } from "./commission-editor.pug?vue&type=template&id=5fa4edff&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./commission-editor.scss?vue&type=style&index=0&id=5fa4edff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa4edff",
  null
  
)

export default component.exports